import { Input, Select, SelectItem } from "@heroui/react";
import { FilterCard } from "@/components/data-table";

/**
 * Filter component for Staff page
 *
 * @param {Object} filterOptions - Options for select filters (passed from parent)
 *   - positions: Array of { value, title }
 *   - departments: Array of { value, title }
 *   - statuses: Array of { value, title }
 */
const FilterData = ({ table, initialFilters, filterOptions = {} }) => {
    const { filterPanel } = table;
    const { isOpen, pending, setPending, apply, clear } = filterPanel;

    const {
        positions = [],
        departments = [],
        employmentStatuses = [],
    } = filterOptions;

    // Handle clear - reset to initial values
    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            {/* Nama Staff */}
            <Input
                label="Nama Staff"
                placeholder="Cari nama staff..."
                value={pending.name || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        name: val,
                    }))
                }
                variant="flat"
                isClearable
            />

            {/* Position */}
            <Select
                label="Jabatan"
                placeholder="Pilih jabatan"
                selectedKeys={
                    pending.position_id
                        ? new Set([String(pending.position_id)])
                        : new Set()
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        position_id: Array.from(keys)[0],
                    }))
                }
                variant="flat"
            >
                {positions.map((item) => (
                    <SelectItem key={String(item.value)} value={item.value}>
                        {item.title}
                    </SelectItem>
                ))}
            </Select>

            {/* Department */}
            <Select
                label="Departemen"
                placeholder="Pilih departemen"
                selectedKeys={
                    pending.department_id
                        ? new Set([String(pending.department_id)])
                        : new Set()
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        department_id: Array.from(keys)[0],
                    }))
                }
                variant="flat"
            >
                {departments.map((item) => (
                    <SelectItem key={String(item.value)} value={item.value}>
                        {item.title}
                    </SelectItem>
                ))}
            </Select>

            {/* Status Kepegawaian */}
            <Select
                label="Status"
                placeholder="Pilih status"
                selectionMode="multiple"
                selectedKeys={
                    new Set(
                        Array.isArray(pending.employment_status_id)
                            ? pending.employment_status_id.map(String)
                            : [],
                    )
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        employment_status_id: Array.from(keys),
                    }))
                }
                variant="flat"
            >
                {employmentStatuses.map((item) => (
                    <SelectItem key={String(item.value)} value={item.value}>
                        {item.title}
                    </SelectItem>
                ))}
            </Select>
        </FilterCard>
    );
};

export default FilterData;
